import { TSDStatus, TSDTestResponseType } from '../../enums';

export interface TsdSimulatorAvailabilityResult {
  available: boolean;
  reason?: string;
}

// eslint-disable-next-line max-statements
export const getTsdSimulatorAvailability = (
  messageType: TSDTestResponseType,
  tsdData: { status: TSDStatus; frn?: string; hasInvalidation: boolean },
  // eslint-disable-next-line complexity
): TsdSimulatorAvailabilityResult => {
  const status = tsdData.status;

  if ([TSDTestResponseType.ACCEPTED, TSDTestResponseType.REJECTED].includes(messageType)) {
    if (status !== TSDStatus.SENT) {
      return {
        available: false,
        reason: 'Only available when the TSD status is Sent',
      };
    }

    return { available: true };
  }

  if (TSDTestResponseType.TSD_ACTIVATION === messageType) {
    if (![TSDStatus.PRESENTED, TSDStatus.LINKED].includes(status)) {
      return {
        available: false,
        reason: 'Only available when the TSD status is Presented or Linked',
      };
    }

    return { available: true };
  }
  if (TSDTestResponseType.PN_LINKING_RESULT === messageType) {
    if (status !== TSDStatus.PRESENTED) {
      return {
        available: false,
        reason: 'Only available when the TSD status is Presented or Linked',
      };
    }

    return { available: true };
  }

  if (messageType === TSDTestResponseType.WRITE_OFF) {
    if (status && ![TSDStatus.ACCEPTED, TSDStatus.CLEARED].includes(status)) {
      return {
        available: false,
        reason: 'Only available when the TSD status is Accepted or Cleared',
      };
    }

    return { available: true };
  }

  if (messageType === TSDTestResponseType.INVALIDATION_CONFIRMATION) {
    if (status === TSDStatus.PRELODGED || tsdData.hasInvalidation) {
      return { available: true };
    }

    return {
      available: false,
      reason: 'Only available when the TSD status is Prelodged or after an invalidation request was sent',
    };
  }

  if (messageType === TSDTestResponseType.INTENDED_CONTROL_NOTIFICATION) {
    if (status && ![TSDStatus.ACCEPTED, TSDStatus.CLEARED].includes(status)) {
      return {
        available: false,

        reason: 'Only available when the TSD status is Accepted or Cleared',
      };
    }

    return { available: true };
  }

  return { available: true };
};
